<template>
  <div class="weapon-cases-container">
    <Banner :bannerList="bannerList" />
    <Cases :casesList="casesList" />
    <Footer ref="footerRef"></Footer>
    
    <!-- <div class="backTop" v-if="showBack" @click="handlerBackTop('.cases-container')">
      <div class="wrap">UP</div>
    </div> -->
  </div>
</template>

<script>
import Banner from "./components/banner";
import Cases from "./components/cases";
import responsiveMixin from "@/mixins/responsive";
import { JSONSTORAGEADDRESS } from "@/config";
import { fireCase } from "@/api/json";
import Footer from "./components/footer/index.vue";

export default {
  name: "Matr1xFireWeaponCases",
  mixins: [responsiveMixin],
  components: { Banner, Cases, Footer },
  props: {},
  data() {
    return {
      bannerList: null,
      casesList: null,
      showBack: false
    };
  },
  mounted() {
    this.getJsonConfig();
    this.handleScroll();
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    getJsonConfig() {
      fetch((process.env.NODE_ENV === 'development' ? '' : JSONSTORAGEADDRESS) + fireCase).then(async res => {
        if (res.status == 200) {
          const result = await res.json();
          this.bannerList = result.banner;
          this.casesList = result.case;
        }
      })
    },
    handleScroll() {
      requestAnimationFrame(() => {
        this.showBack = window.scrollY > 1200;
      });
    },
    handlerBackTop(dom) {
      // window.scrollTo({
      //   top: 0,
      //   behavior: "smooth"
      // });
      document.querySelector(dom).scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  },
  watch: {}
};
</script>

<style lang="scss">
.weapon-cases-main-width {
  width: 100%;
  max-width: 1580px;
  margin: 0 auto;
  font-family: Poppins-Regular !important;
  box-sizing: border-box;

  @media screen and (min-width: 769px) and (max-width: 1580px) {
    max-width: 100%;
    width: 100%;
    padding: 0 40px;
  }

  @media screen and (max-width: 769px) {
    max-width: 100%;
    width: 100%;
    padding: 0 16px;
  }
}
</style>

<style lang="scss" scoped>
@import "./index.scss";
</style>
